import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
import 'firebase/compat/storage'

const firebaseConfig = {
  projectId: 'agrari-3e96e',
  appId: '1:922833137487:web:d20d4ca72ed414cfb4df3a',
  storageBucket: 'agrari-3e96e.firebasestorage.app',
  apiKey: 'AIzaSyDGnIeyVGYN-METjlN93bmjHayyTMnnBg0',
  authDomain: 'agrari-3e96e.firebaseapp.com',
  messagingSenderId: '922833137487',
  measurementId: 'G-008J82MV6T',
}

const dbApp = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig)

export const db = dbApp.firestore()
export const storage = dbApp.storage()

export const getCompanyId = async (forceRefresh = false) => {
  const user = dbApp.auth().currentUser
  if (!user) throw new Error('Tu sesión expiró. Inicia sesión nuevamente.')
  const token = await user.getIdTokenResult(forceRefresh)
  const companyId = token.claims.companyId
  if (!companyId || String(companyId).includes('/')) {
    throw new Error('Tu usuario no está asociado a una empresa.')
  }
  return companyId
}

export const getCompanyCollection = async collectionName => {
  const companyId = await getCompanyId()
  return db.collection('companies').doc(companyId).collection(collectionName)
}

export const getCompanyDocument = async () => {
  const companyId = await getCompanyId()
  return db.collection('companies').doc(companyId)
}

export const SignUp = async (email, password, nombre, rol = 'user') => {
  const currentUser = dbApp.auth().currentUser
  if (!currentUser) {
    throw new Error('Tu sesión expiró. Inicia sesión nuevamente antes de registrar un empleado.')
  }
  // Fuerza un token vigente antes de llamar la función protegida que asigna el rol.
  await currentUser.getIdToken(true)
  const createEmployee = dbApp.functions('us-central1').httpsCallable('createEmployee')
  const result = await createEmployee({correo: email, nombre, rol})
  return result.data.uid
}

export default dbApp
